import {
  ProductPreferences,
  ServerProductPreferencesFetch,
  ClearProductPreferencesErrorAction,
  CreateProductPreferencesAction,
  CreateProductPreferencesFailAction,
  CreateProductPreferencesSuccessAction,
  DeleteProductPreferencesAction,
  DeleteProductPreferencesFailAction,
  DeleteProductPreferencesSuccessAction,
  FetchProductPreferencesAction,
  FetchProductPreferencesFailAction,
  FetchProductPreferencesSuccessAction,
  UpdateProductPreferencesAction,
  UpdateProductPreferencesFailAction,
  UpdateProductPreferencesSuccessAction,
  UpsertProductPreferencesAction,
  UpsertProductPreferencesFailAction,
  UpsertProductPreferencesSuccessAction,
} from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function clearProductPreferencesError(): ClearProductPreferencesErrorAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.CLEAR_PRODUCT_PREFERENCES_ERROR };
}

export function createProductPreferences(
  applicationId: string,
  productPreferences: ProductPreferences
): CreateProductPreferencesAction {
  return {
    type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.CREATE_PRODUCT_PREFERENCES,
    applicationId,
    productPreferences,
  };
}

export function createProductPreferencesFail(
  clientId: string,
  message: string = 'Unknown error'
): CreateProductPreferencesFailAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.CREATE_PRODUCT_PREFERENCES_FAIL, clientId, message };
}

export function createProductPreferencesSuccess(clientId: string, id: string): CreateProductPreferencesSuccessAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.CREATE_PRODUCT_PREFERENCES_SUCCESS, clientId, id };
}

export function deleteProductPreferences(applicationId: string, clientId: string): DeleteProductPreferencesAction {
  return {
    type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.DELETE_PRODUCT_PREFERENCES,
    applicationId,
    clientId,
  };
}

export function deleteProductPreferencesFail(
  clientId: string,
  message: string = 'Unknown error'
): DeleteProductPreferencesFailAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.DELETE_PRODUCT_PREFERENCES_FAIL, clientId, message };
}

export function deleteProductPreferencesSuccess(): DeleteProductPreferencesSuccessAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.DELETE_PRODUCT_PREFERENCES_SUCCESS };
}

export function fetchProductPreferences(applicationId: string): FetchProductPreferencesAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.FETCH_PRODUCT_PREFERENCES, applicationId };
}

export function fetchProductPreferencesFail(message: string = 'Unknown error'): FetchProductPreferencesFailAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.FETCH_PRODUCT_PREFERENCES_FAIL, message };
}

export function fetchProductPreferencesSuccess(
  productPreferences: ServerProductPreferencesFetch[]
): FetchProductPreferencesSuccessAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.FETCH_PRODUCT_PREFERENCES_SUCCESS, productPreferences };
}

export function updateProductPreferences(
  applicationId: string,
  productPreferences: ProductPreferences
): UpdateProductPreferencesAction {
  return {
    type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.UPDATE_PRODUCT_PREFERENCES,
    applicationId,
    productPreferences,
  };
}

export function updateProductPreferencesFail(
  clientId: string,
  message: string = 'Unknown error'
): UpdateProductPreferencesFailAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.UPDATE_PRODUCT_PREFERENCES_FAIL, clientId, message };
}

export function updateProductPreferencesSuccess(): UpdateProductPreferencesSuccessAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.UPDATE_PRODUCT_PREFERENCES_SUCCESS };
}

export function upsertProductPreferences(
  applicationId: string,
  productPreferences: ProductPreferences[]
): UpsertProductPreferencesAction {
  return {
    type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.UPSERT_PRODUCT_PREFERENCES,
    applicationId,
    productPreferences,
  };
}

export function upsertProductPreferencesFail(message: string = 'Unknown error'): UpsertProductPreferencesFailAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.UPSERT_PRODUCT_PREFERENCES_FAIL, message };
}

export function upsertProductPreferencesSuccess(): UpsertProductPreferencesSuccessAction {
  return { type: REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.UPSERT_PRODUCT_PREFERENCES_SUCCESS };
}
